import React, {Component} from 'react';
import { Group } from 'react-konva';
import RecursiveGroup from '../RecursiveGroup';
import {ICardsRenderInfo, IPile} from '../../redux/types';
import {DraggableCardNumber, onDragEndProps} from "../Laid/Pile/types";

export type changeStateParams = {isDraggingEnd?: boolean, isHintMove?: boolean, draggableCardNumber?: number | null};

export interface ICardGroupProps {
  cards: IPile,
  cardParameters: ICardsRenderInfo,
  onDragEnd: (params: onDragEndProps) => void,
  onDragStart: (draggableCardNumber: DraggableCardNumber) => void,
  onDblClick: (node: any, draggableCardNumber: DraggableCardNumber) => void,
  draggableCardNumber: number | null,
  isDraggingEnd: boolean,
  isHintMove: boolean,
  moveTo: (card: any, x: number, y: number, cardX: number, draggableCardNumber: number) => void,
}

class CardGroup extends Component<ICardGroupProps> {
  __hold__drag__start: boolean = false;
  __hold__drag__end: boolean = false;

  onDragStart = (node: object, draggableCardNumber: number | null) => {
    if (this.__hold__drag__start) return;
    this.__hold__drag__start = true;

    this.props.onDragStart(draggableCardNumber);

    setTimeout(() => { this.__hold__drag__start = false }, 100);
  };

  onDragEnd = (node: any, x: number, y: number, cardIndex: number): void => {
    if (this.__hold__drag__end) return;
    this.__hold__drag__end = true;

    this.props.onDragEnd({ node, startX: x, startY: y, cardIndex });

    setTimeout(() => { this.__hold__drag__end = false }, 100);
  };

  render() {
    const { cards, draggableCardNumber, isDraggingEnd, isHintMove, onDblClick, moveTo, cardParameters } = this.props;

    return (
      <Group>
        <RecursiveGroup
          cardParameters={cardParameters}
          cards={cards}
          onDragEnd={this.onDragEnd}
          onDragStart={this.onDragStart}
          moveTo={moveTo}
          onDblClick={onDblClick}
          draggableCardNumber={draggableCardNumber}
          draggable={!isDraggingEnd}
          isHintMove={isHintMove}
        />
      </Group>
    );
  }
}

export default CardGroup;

